angular.module('lf.common')

.directive('lfSubmitWhen', function() {
  return function (scope, elem, attr) {
    scope.$watch(attr.lfSubmitWhen, function (value) {
      if (value === true) {
        elem.trigger('submit');
      }
    })
  };
});
